import { Button, Flex, Text } from '@welbe/design-system';
import packageLock from '../../../../../package.json';

type SystemInfoModalProps = {
	onClose: () => void;
};

export const SystemInfoModal = ({ onClose }: SystemInfoModalProps) => {
	return (
		<Flex direction="column" gap={2}>
			<Text fontWeight={700} color="blue.500" mb={2}>
				Informaciones del sistema
			</Text>
			<Text fontSize={12} fontWeight={700}>
				ECOSISTEMA DE SALUD DIGITAL WELBE
			</Text>
			<Text fontSize={12}>Versión {packageLock.version}</Text>
			<Button variant="outline" mt={2} onClick={onClose}>
				Cerrar
			</Button>
		</Flex>
	);
};
